// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"edd9db84","239":"2234b7c2","453":"1f41286f","553":"6557ada5"}[chunkId] + ".chunk.js";
};